import React from 'react';
import type { Dispatch, SetStateAction } from 'react';
import {
  Icon,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
} from '@saviynt/design-system';

import { useInvertedLocalize } from '../../../../utils/localization';
import { invertedMessages } from '../../../../utils/messages';
import { TOGGLE_VALUES, type ToggleSelectionType } from '../../types';

import './SqlErrorToggle.css';

interface SqlErrorToggleProps {
  detailedSteps?: string[];
  toggleSelection?: ToggleSelectionType;
  setToggleSelection?: Dispatch<SetStateAction<ToggleSelectionType>>;
  sqlQuery?: string;
}
SqlErrorToggle.defaultProps = {
  detailedSteps: [],
  toggleSelection: undefined,
  setToggleSelection: () => {},
  sqlQuery: '',
};

function SqlErrorToggle({
  toggleSelection,
  setToggleSelection,
  detailedSteps,
  sqlQuery,
}: SqlErrorToggleProps): JSX.Element {
  const tooltipSteps = Array.isArray(detailedSteps)
    ? detailedSteps.join('\n')
    : '';

  const l = useInvertedLocalize(invertedMessages);

  return (
    <section className='Ispm-SqlErrorToggle'>
      <div className='Ispm-SqlErrorToggle-contentWrapper'>
        <span
          className='Ispm-SqlErrorToggle-contentWrapper-toggleGroup'
          aria-label={l('Toggle button group for switching views')}>
          {toggleSelection === TOGGLE_VALUES.SQL && (
            <Tooltip
              text={tooltipSteps}
              placement='left'
              trigger={<Icon kind='Info' color='info-700' size='xSmall' />}
            />
          )}

          <ToggleButtonGroup
            selection={toggleSelection}
            setSelection={setToggleSelection}
            isPill>
            <ToggleButton
              size='small'
              icon={
                <Tooltip
                  text='View Visualization'
                  placement='top'
                  offset={20}
                  trigger={
                    <Icon kind='DataAnalyze' size='small' color='navy-900' />
                  }
                />
              }
            />

            <ToggleButton
              size='small'
              icon={
                <Tooltip
                  text='View SQL'
                  placement='top'
                  offset={20}
                  trigger={<Icon kind='Code' size='small' color='navy-900' />}
                />
              }
              isDisabled={!sqlQuery?.length}
            />
          </ToggleButtonGroup>
        </span>
      </div>
    </section>
  );
}

export default SqlErrorToggle;
